import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { Consultant } from '../../../models/Consultant.model';
import { ConsultantService } from '../../../services/consultant.service';
import { ToastsManager, Toast } from 'ng2-toastr/ng2-toastr';
import * as moment from 'moment';

@Component({
  selector: 'app-create-approval-box',
  templateUrl: './create-approval-box.component.html',
  styleUrls: ['./create-approval-box.component.scss']
})
export class CreateApprovalBoxComponent implements OnInit {
  @Input() approval;
  @Input() consultantsBorrowInvoice;
  @Output() sendApprovalData: EventEmitter<any> = new EventEmitter<any>();
  mensalHours: number = 0;
  hourValue: number = 0;
  contractTotalValue: number = 0;
  kind: number = 0;
  honorarium: number = 0;
  active: boolean = false;
  borrowInvoice: boolean = false;
  consultantApproval: Consultant;

  constructor(
    public commonHelper:CommonHelper,
    private toastr: ToastsManager,
    private consultantService:ConsultantService
  ) { }

  ngOnInit(){
      this.setValues(this.approval)
      this.approval.manualApproval = {  created:false,
                                        totalEdited:false,
                                        hoursEdited:false
                                    }
      this.approval.manualApproval.created = true;

      if(this.kind == 1)
        this.checkBorrowInvoiceConsultant();
  }

    valueCheck(projectHours, totalValue){
        if(Math.abs(projectHours - totalValue)<= 1){
            return true;
        }
        return false;
    }

    calculate() {
            this.approval.manualApproval.hoursEdited = true;
            this.approval.realizedHours = 0;
            this.approval.projects.forEach(project =>{
                this.approval.realizedHours += project.total_hours;
                project.approvedHours = project.total_hours;
                project.approvedValue = (project.total_hours && this.approval.consultant.contract.hourValue)?(project.total_hours*this.approval.consultant.contract.hourValue):0;
            });
            this.approval.totalHourValue = 0;
            this.approval.totalSoldHourValue = 0;
            this.approval.totalHourValue = this.approval.consultant.contract.hourValue * this.approval.realizedHours;
            this.approval.totalValue = this.valueCheck(this.approval.totalHourValue,this.approval.consultant.contract.totalValue.valueOf())?this.approval.consultant.contract.totalValue.valueOf():this.approval.totalHourValue;
            this.approval.totalSoldHourValue = this.approval.consultant.contract.soldHourValue * this.approval.realizedHours;
    }

    setValues(approval){
        if(approval.consultant.contract.mensalHours)
            this.mensalHours = approval.consultant.contract.mensalHours;

        this.hourValue = approval.consultant.contract.hourValue;

        if(approval.consultant.contract.totalValue)
            this.contractTotalValue = approval.consultant.contract.totalValue;

        this.kind = approval.consultant.contract.kind;

        if(approval.consultant.contract.honorarium)
            this.honorarium = approval.consultant.contract.honorarium;

        if(approval.consultant.active)
            this.active = approval.consultant.active

    }

    calculateProjectValue(){
        this.approval.manualApproval.totalEdited = true;
        this.approval.projects.forEach(project =>{
            project.approvedValue = (this.approval.totalValue/this.approval.realizedHours)*project.total_hours;
        });
    }

    getHonorarium() {
        if(this.honorarium){
            switch(this.honorarium){
                case 1:
                    return 'Hora Aberta';
                case 2:
                    return 'Hora Fechada';
            }
        }else{
            return null;
        }
    }

    onClickExtras(){
        if(this.approval.extras == true){
            this.approval.discountHours = 0;
            this.approval.discounted = false;
            this.approval.discountValue = 0;
        }
    }

    onClickDiscount(){
        if(this.approval.discounted == true){
            this.approval.extras = false;
            this.approval.extrasHours = 0;
            this.approval.extrasValue = 0;
        }
    }

    changeBorrow(){
        if(!this.borrowInvoice)
            this.clearBorrow()
    }

    changeConsultantBorrow(){
        if(this.approval.borrowedInvoice._id == ''){
            this.clearBorrow()
        } else {
            const borrowedInvoice = this.consultantsBorrowInvoice.find(cb => cb._id == this.approval.borrowedInvoice._id)
            const {contract, hashTrackId, fcEmail, ...borrowedInvoiceData} = borrowedInvoice;
            this.approval.borrowedInvoice = Object.assign({}, borrowedInvoiceData, {
                cnpj: contract.cnpj,
                sapServiceCode: contract.sapServiceCode
            })
            this.sendApprovalData.emit(this.approval.borrowedInvoice);
        }
    }

    clearBorrow(){
        this.approval.borrowedInvoice._id = ''
        this.approval.borrowedInvoice.name = ''
        this.approval.borrowedInvoice.sapCardCode = ''
        this.approval.borrowedInvoice.sapServiceCode = ''
        this.approval.borrowedInvoice.cnpj = ''
    }

    isActive(active: boolean) {
        return active ? "badge-success" : "badge-danger";
    }

    isActiveText(active: boolean) {
        return active ? "Consultor Ativo" : "Consultor Inativo";
    }

    async checkBorrowInvoiceConsultant() {
        this.consultantApproval = await this.consultantService.getById(this.approval.consultant._id);
        const borrowData = { ...this.consultantApproval.borrowInvoiceNote }
        if(borrowData && borrowData.lenderId) {
            const lender = this.consultantsBorrowInvoice.find(lender => lender._id === borrowData.lenderId);
            if(lender) {
                const start = moment(borrowData.start).format('DD/MM/YYYY');
                const end = moment(borrowData.end).format('DD/MM/YYYY');

                this.toastr.info(
                    `O consultor selecionado possui empréstimo em seu cadastro no perído de ${start} a ${end} concedido por ${lender.name}`,
                    'Empréstimo Automático',
                    { dismiss: 'controlled' }
                ).then((t: Toast) => { setTimeout(() => { this.toastr.dismissToast(t) }, 9000) })

                this.borrowInvoice = true;
                this.approval.borrowedInvoice = {
                    _id: lender._id,
                    name: lender.name,
                    sapCardCode: lender.sapCardCode,
                    sapServiceCode: lender.contract.sapServiceCode,
                    cnpj: lender.contract.cnpj
                }
            }
        } else {
            this.approval.borrowedInvoice = {
                _id: '',
                name: '',
                sapCardCode: '',
                sapServiceCode: '',
                cnpj: ''
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/approvals/create-approval-box/create-approval-box.component.ts